import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router";
import { HelmetProvider } from "react-helmet-async";

// Lazy-load pages (named exports need the .then wrapper)
const HomeMainComponent = lazy(() =>
  import("./components/home/HomeMainComponent").then((m) => ({
    default: m.HomeMainComponent,
  })),
);
const ContactUsComponent = lazy(() =>
  import("./components/contact/contact").then((m) => ({
    default: m.ContactUsComponent,
  })),
);
const AboutUsComponent = lazy(() =>
  import("./components/about/AboutUs").then((m) => ({
    default: m.AboutUsComponent,
  })),
);
const CourseListComponent = lazy(() =>
  import("./components/courses/CourseList").then((m) => ({
    default: m.CourseListComponent,
  })),
);
const CourseDetail = lazy(() =>
  import("./components/courses/CourseDetail").then((m) => ({
    default: m.CourseDetail,
  })),
);
const TermsComponent = lazy(() =>
  import("./components/Terms/Term").then((m) => ({
    default: m.TermsComponent,
  })),
);
const TrainersSection = lazy(() => import("./components/Trainers/Trainers"));
const TrainerDetailsPage = lazy(
  () => import("./components/Trainers/TrainerDetails"),
);
const NotesComponent = lazy(() => import("./components/Notes/NotesComponent"));
const NotFound = lazy(() => import("./components/NotFound/NotFound")); // create this

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomeMainComponent />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/contact" element={<ContactUsComponent />} />
            <Route path="/about" element={<AboutUsComponent />} />
            <Route path="/courses" element={<CourseListComponent />} />

            {/* Course detail: supports both URL shapes
                /courses/cbse-cs-11
                /courses/computer-science/cbse-cs-11 */}
            <Route path="/courses/:slug" element={<CourseDetail />} />
            <Route path="/courses/:category/:slug" element={<CourseDetail />} />

            <Route path="/trainers" element={<TrainersSection />} />
            <Route path="/trainers/:slug" element={<TrainerDetailsPage />} />
            <Route path="/terms" element={<TermsComponent />} />
            <Route path="/notes" element={<NotesComponent />} />

            {/* Redirect old URLs so existing links keep working */}
            <Route
              path="/Trainer"
              element={<Navigate to="/trainers" replace />}
            />
            <Route
              path="/trainers-details"
              element={<Navigate to="/trainers" replace />}
            />

            {/* 404 catch-all */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
